import React from "react";
import image from "../images";
import { Link } from 'react-router-dom';
import "../css/familyCard.css";

function FamilyCard({ pet }) {

  return (
    <div className="family-box">
      <div className="family-card-div">
        <Link className="family-link" to={`/info/${pet._id}`}>
          <button className="img-btn">
            <img className="pic" src={pet.petImageUrl} alt="pets-pic" />
            {/* <img className="footprints" src={image.footprints} alt="footprints-pic" /> */}
          </button>
        </Link>
        <div className="family-card-div">
          <Link className="family-link" to={`/info/${pet._id}`}>
            <button className="details-btn">
              <h2 className="name">{pet.petname}{pet.sex == "Male" ? <i id="family-card-sexIcon" className="fa-solid fa-mars"></i> : <i id="family-card-sexIcon" className="fa-solid fa-venus"></i>}</h2>
              <h3 className="breed">{pet.breed}</h3>
              <p className="age">{pet.age}</p>
              <p className="location"><i className="familyCard-locationIcon fa-solid fa-location-dot"></i>{pet.address}</p>
            </button>
          </Link>
        </div>
      </div>

    </div>
  );
}

export default FamilyCard;
